import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { NotifierService } from 'angular-notifier';
import { BaseComponent } from 'src/app/shared/components/base/base.component';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { Message } from 'src/app/core/class/message';
import { CreateContractService } from 'src/app/core/services/create-contract.service';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import Handsontable from 'handsontable';
import { FormTemplateComponent } from './form-template/form-template.component';
import { forkJoin, Subscription } from 'rxjs';
import { TemplateFileService } from 'src/app/core/services/template-file.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatGridTileHeaderCssMatStyler } from '@angular/material';
import { SelectDocumentTypeComponent } from '../../select-document-type/select-document-type.component';
import { ActivatedRoute } from '@angular/router';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { SignatureConfigService } from "src/app/core/services/signature-config.service";
import { FootNoteComponent } from './footnote/footnote.component';
import { DialogPreviewPdfComponent } from '../../../document-management/dialog-preview-pdf/dialog-preview-pdf.component';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { DocumentTemplate } from 'src/app/shared/models/document-template.model';
import { TemplateFile } from 'src/app/shared/models/template-file.model';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { TemplateFormService } from 'src/app/core/services/template-form.service';

@Component({
  selector: 'app-document-form',
  templateUrl: './document-form.component.html',
  styleUrls: ['./document-form.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DocumentFormComponent extends BaseComponent implements OnInit, OnDestroy {
  @BlockUI() blockUI: NgBlockUI;

  @ViewChild('formTemplate', { static: true })
  public formTemplate: FormTemplateComponent;

  public templateId: number;
  private isExport: boolean = false;

  private subcription: Subscription = new Subscription();
  private isUpdate: boolean = false;
  public documentTemplateFile: TemplateFile = null;
  public name: string;
  public url: string;
  public selectedIndex: number = 0;
  public showWarning: boolean = false;

  constructor(
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private createContractService: CreateContractService,
    private documentTemplateService: DocumentTemplateService,
    private templateFileService: TemplateFileService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public changeDetector: ChangeDetectorRef,
    public signatureConfigService: SignatureConfigService,
    public documentTypeService: DocumentTypeService,
    public templateFormService: TemplateFormService,
    private cdr: ChangeDetectorRef,
  ) {
    super(commonService, message);
    this.notifier = notifier;

    this.route.queryParams.subscribe(queryParams => {
      if (queryParams.typeUpdate) {
        this.isUpdate = true;
      }
    })

    const exportDataSub = this.createContractService.isExportData.subscribe(isExport => {
      if (isExport && !this.isExport) {
        this.isExport = true;
        // if (!this.createContractService.isValidForm.getValue() && this.selectedIndex === 1) {
        //   this.selectedIndex = 0;
        //   return;
        // }
        // if (this.selectedIndex === 0) {
        this.formTemplate.exportDataField();
        // } else {
        //   this.mergeFieldToFile();
        // }
      }
      if (!isExport) {
        this.isExport = false;
      }
    });
    this.subcription.add(exportDataSub);
    const saveDataSub = this.createContractService.saveDataTable.subscribe(save => {
      if (save) {
        this.formTemplate.saveDataTable(true);
      }
    })
    this.subcription.add(saveDataSub);
  }

  ngOnInit() {
    this.createContractService.selectedTemplate.asObservable().subscribe(template => {
      if (this.createContractService.currentStep.getValue() !== 1) {
        return;
      }
      const userSign = this.createContractService.recordsPartySign.getValue();
      const tableModel = this.createContractService.tableModel;
      const signatureData = this.createContractService.signatureData.getValue();
      if (tableModel) {
        if (this.createContractService.isCopy) {
          this.formTemplate.processDataWithModel(tableModel, userSign && userSign.length ? userSign : [], true);
          this.createContractService.isCopy = false;
        } else {
          this.formTemplate.processDataWithModel(tableModel, userSign && userSign.length ? userSign : []);
        }
        // this.signature.showSignatureFromData(signatureData ? signatureData : [], userSign && userSign.length ? userSign : []);
        if (template && template.id) {
          this.getTemplateFile(template.id);
        }
        const document = this.createContractService.document.getValue();
        if (document && document.templateFilePath) {
          this.url = document.templateFilePath;
        }
        return;
      }
      if (template && template.id) {
        this.formTemplate.generateForm(template.id, userSign && userSign.length ? userSign : []);
        // this.signature.genSignature(template.id, userSign && userSign.length ? userSign : []);
        this.getTemplateFile(template.id);
      }
    });
    this.createContractService.document.subscribe((ref: any) => {
      if (ref && ref.editedLotContract === false) {
        this.showWarning = true;
      }
    })
  }

  ngOnDestroy(): void {
    this.subcription.unsubscribe();
  }

  getTemplateFile(id: string) {
    this.documentTemplateService.getDocumentTemplateById(id).subscribe(response => {
      if (!response || !response.data) {
        if (this.isUpdate) {
          if (response && response.code === ErrorCode.NotPermissionTemplate) {
            this.toastr.error(this.message.getMessage('messages.check_permission'));
          }
        } else {
          this.documentInactiveHandler();
        }
        return;
      }
      this.createContractService.documentTemplate = response.data;
      this.name = response.data.name ? response.data.name : '';
      this.signatureConfigService.getAllSignature(response.data.documentTemplateId).subscribe(res => {
        const currentTemplate = this.createContractService.selectedTemplate.getValue();
        if (currentTemplate && currentTemplate.id === id) {
          this.formTemplate.setSignatureConfigs(res && res.data ? res.data : []);
        }
      });
      this.templateFileService.getTemplateFile(response.data.documentTemplateId).subscribe(res => {
        if (!res || !res.data || !res.data.length) {
          return;
        }
        this.createContractService.documentFileTemplate.next(res.data[0]);
        this.documentTemplateFile = res.data[0];
      });
    })
  }

  private documentInactiveHandler() {
    if (!this.toastr.findDuplicate(this.message.getMessage("messages.confirm_use_inactive_template"), true, true)) {
      this.toastr.error(this.message.getMessage("messages.confirm_use_inactive_template"));
      const dialogRef = this.dialog.open(SelectDocumentTypeComponent, {
        width: '30%',
        disableClose: true,
        data: { mode: null }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (typeof result !== 'undefined') {
          this.createContractService.selectedTemplate.next(result.data.documentTypeEnterprise);
        }
      });
    }
  }

  // public changeTab(event: any) {
  //   this.selectedIndex = event.index;
  //   if (event.index === 0) {
  //     this.formTemplate.rerender(() => {
  //       const userSign = this.createContractService.recordsPartySign.getValue();
  //       const tableModel = this.createContractService.tableModel;
  //       if (tableModel) {
  //         this.formTemplate.processDataWithModel(tableModel, userSign && userSign.length ? userSign : [], this.createContractService.isExportData.getValue());
  //         if (this.createContractService.isExportData.getValue()) {
  //           this.createContractService.isExportData.next(false);
  //         }
  //         return;
  //       }
  //     });
  //   } else {
  //     this.formTemplate.saveDataTable();
  //   }
  // }

  preview(event: any) {
    event.stopPropagation();
    if (this.url) {
      this.templateFileService.convertDocxToPdf({ url: this.url }).subscribe(rs => {
        if (!rs) {
          return;
        }
        this.dialog.open(DialogPreviewPdfComponent, {
          width: '80%',
          data: {
            file: rs,
            name: this.name,
          },
        });
      })
    } else if (this.documentTemplateFile) {
      this.templateFileService.getContentTemplateFileByUrl({
        type: 'TEMPLATE_PDF',
        url: this.documentTemplateFile.file.pdfUrl
      }).subscribe(rs => {
        if (!rs) {
          return;
        }
        this.dialog.open(DialogPreviewPdfComponent, {
          width: '80%',
          data: {
            file: rs,
            name: this.name,
          },
        });
      })
    }

  }

  // mergeFieldToFile() {
  //   this.blockUI.start('');
  //   this.cdr.detectChanges();
  //   const fields = this.createContractService.fieldData;

  //   let url = this.documentTemplateFile && this.documentTemplateFile.file && this.documentTemplateFile.file.url;
  //   const document = this.createContractService.document.getValue() as any;
  //   if (document && document.templateFilePath) {
  //     url = document.templateFilePath
  //   }
  //   if (!url) {
  //     this.createContractService.isExportData.next(false);
  //     this.blockUI.stop();
  //     this.cdr.detectChanges();
  //     return;
  //   }
  //   this.templateFormService.mergeDataToFile({ list: fields, url: url }).subscribe(res => {
  //     // if (res && res.type === 'application/json') {
  //     //     this.createContractService.isExportData.next(false);
  //     //     this.proccessSuccess.next(false);
  //     //     return;
  //     // }
  //     this.commonService.readFile(res, (pdfSrc) => {
  //       this.createContractService.pdfSrc.next(pdfSrc);
  //     });
  //     this.createContractService.changeFileOutput = false;
  //     this.createContractService.fileExport = res;
  //     this.createContractService.isExportData.next(false);
  //     this.createContractService.isSuccessStep2.next(true);
  //     this.blockUI.stop();
  //     this.cdr.detectChanges();
  //   });
  // }
}
